<template>
  <a
    class="whatsapp-button"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Hacer un pedido por WhatsApp"
  >
    <span class="whatsapp-icon" aria-hidden="true">✆</span>
    <span class="whatsapp-label">Pedir por WhatsApp</span>
  </a>
</template>

<script>
// Cambia únicamente este número. Usa código de país y solo dígitos, sin +, espacios ni guiones.
const WHATSAPP_NUMBER = '5215649522092'

const WHATSAPP_MESSAGE = 'Hola, quiero hacer un pedido en Juliam Arcade.'

export default {
  name: 'WhatsAppButton',
  computed: {
    whatsappUrl() {
      return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`
    }
  }
}
</script>

<style scoped>
.whatsapp-button {
  position: fixed;
  right: max(22px, env(safe-area-inset-right));
  bottom: max(22px, env(safe-area-inset-bottom));
  z-index: 30;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 58px;
  padding: 8px 17px 8px 9px;
  border: 1px solid rgba(167, 255, 79, .82);
  border-radius: 999px;
  color: #08110a;
  background: linear-gradient(135deg, #a7ff4f, #50ef82);
  box-shadow: 0 0 0 4px rgba(167, 255, 79, .08), 0 8px 30px rgba(55, 226, 114, .28);
  font: 900 11px/1 ui-monospace, SFMono-Regular, Menlo, monospace;
  letter-spacing: .06em;
  text-transform: uppercase;
  text-decoration: none;
  transition: transform .18s ease, box-shadow .18s ease;
}

.whatsapp-button:hover,
.whatsapp-button:focus-visible {
  transform: translateY(-3px);
  box-shadow: 0 0 0 5px rgba(167, 255, 79, .12), 0 12px 36px rgba(55, 226, 114, .38);
  outline: none;
}

.whatsapp-icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 40px;
  border: 2px solid rgba(8, 17, 10, .72);
  border-radius: 50%;
  font: 900 25px/1 Arial, sans-serif;
  transform: rotate(-18deg);
}

.whatsapp-label {
  white-space: nowrap;
}

@media (max-width: 680px) {
  .whatsapp-button {
    right: max(16px, env(safe-area-inset-right));
    bottom: max(16px, env(safe-area-inset-bottom));
    width: 56px;
    min-height: 56px;
    padding: 7px;
    justify-content: center;
  }

  .whatsapp-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }

  .whatsapp-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .whatsapp-button {
    transition: none;
  }
}
</style>
